import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { CoreService } from 'src/app/core/helpers/core.service';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { GaService } from 'src/app/core/helpers/ga.service';



@Component({
  selector: 'loyaltic-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('fadeSlideInOut', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate('500ms', style({ opacity: 1, transform: 'translateY(0)', })),
      ]),
      // transition(':leave', [
      //   animate('300ms', style({ opacity: 0, transform: 'translateY(-20px)' })),
      // ]),

    ]),


    trigger('slideInLeft', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(20px)' }),
        animate('500ms', 
        style({ opacity: 1, transform: 'translateX(0)', })),
      ]),
      // transition(':leave', [
      //   animate('200ms',
      //   style({ opacity: 0, transform: 'translateX(-10px)' })),
      // ]),
    ]),
    
  ]
})
export class ProfileComponent implements OnInit {
  isProfileLoading = false;
  isShowMyProfile = false;
  isShowProfileOrders = true;
  isShowProfileCodes = false;
  userId = '';
  userType = '';
  userOrders = [];
  userRaffles = [];
  userReceipts = [];
  isLoggedIn = false;
  results: any;

  constructor(private coreService: CoreService, private authService: AuthService,
    private modalService: BsModalService, private translate: TranslateService, private toast: ToastrService,
    private router: Router, private gaService: GaService) {
    this.userId = authService.getUserId();
    this.userType = authService.getUserType();
    this.isLoggedIn = authService.IsLoggedIn()
  }

  ngOnInit() {
    this.getProfile();
  }

  getProfile() {
    this.isProfileLoading = true;
    this.coreService.getprofile(this.userId).then((response: any) => {
      this.results = response.result;
      this.userOrders = response.result.userOrders.filter((order: any) => !order.isRaffle);
      this.userRaffles = response.result.userOrders.filter((order: any) => order.isRaffle);
      this.userReceipts = response.result.userReceipts;
      this.isProfileLoading = false;
    });
  }

  showMyProfile(){  
    this.isShowMyProfile = true;
    this.isShowProfileOrders = false;
    this.isShowProfileCodes = false;
  }
  showProfileOrders(){
    this.isShowProfileOrders = true;
    this.isShowMyProfile = false;
    this.isShowProfileCodes = false;
  }
  showProfileCodes(){
    this.isShowProfileCodes = true;
    this.isShowMyProfile = false;
    this.isShowProfileOrders = false;
  }
}
